import React, { useEffect, useState } from "react";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
import CustomDataTableSearch from "../../../../../partials/content/CustomDataTableSearch";
import ResponsiveEllipsis from "../../../../../partials/content/ResponsiveEllipsis";
import { getSalesOrder } from "../../../../../services/sales/salesOrderService";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import { formatDate } from "../../../../../utils/utils";

function SearchDeliveredItem({ salesOrderID = 0, onSelectDeliveredItem }) {
  const { reload } = useGlobalData();
  const [deliveredItems, setDeliveredItems] = useState([]);
  useEffect(() => {
    getSoDeliveredItems(salesOrderID);
  }, [reload]);

  async function getSoDeliveredItems(salesOrderID = 0) {
    const response = await getSalesOrder(salesOrderID);
    const { data } = response.data;
    setDeliveredItems(data.deliveredItems);
  }

  return (
    <CustomDataTableSearch
      data={deliveredItems}
      onRefreshData={() => {
        getSoDeliveredItems(salesOrderID);
      }}
      onSelectedData={(rowData, originalEvent) => {
        onSelectDeliveredItem(rowData);
      }}
      columns={[
        {
          field: "select",
          body: (rowData) => (
            <React.Fragment>
              <button
                type="button"
                className="btn btn-label-success btn-sm btn-pill btn-bold"
                onClick={() => onSelectDeliveredItem(rowData)}
              >
                Select <i className="fas fa-angle-double-right"></i>
              </button>
            </React.Fragment>
          ),
        },
        {
          header: "Delivery ID",
          field: "deliveryID",
          body: null,
          sortable: true,
        },
        {
          header: "Outlet Name",
          field: "outletName",
          body: (rowData) => (
            <React.Fragment>
              <ResponsiveEllipsis text={rowData.outletName} maxLine="1" />
            </React.Fragment>
          ),
          sortable: true,
        },
        {
          header: "Warehouse Name",
          field: "warehouseName",
          body: (rowData) => (
            <React.Fragment>
              <ResponsiveEllipsis text={rowData.warehouseName} maxLine="1" />
            </React.Fragment>
          ),
          sortable: true,
        },
        {
          header: "Delivery Date",
          field: "deliveryDate",
          body: (rowData) => formatDate(rowData.deliveryDate),
          sortable: true,
        },
        {
          header: "Item Type",
          field: "itemTypeName",
          body: (rowData) => (
            <React.Fragment>
              <ResponsiveEllipsis text={rowData.itemTypeName} maxLine="1" />
            </React.Fragment>
          ),
          sortable: true,
          hidden: true,
        },
        {
          header: "Item Code",
          field: "itemCode",
          body: (rowData) => (
            <React.Fragment>
              {rowData.itemType > 0 ? (
                <span>
                  <BootstrapTooltip title={rowData.itemTypeName}>
                    <span className="mr-2">
                      <i
                        className={
                          rowData.itemType === 1
                            ? "fas fa-boxes text-success"
                            : rowData.itemType === 2
                            ? "fas fa-tools text-primary"
                            : rowData.itemType === 3
                            ? "fas fa-building text-info"
                            : rowData.itemType === 4
                            ? "fas fa-boxes text-warning"
                            : rowData.itemType === 5
                            ? "fas fa-boxes text-danger"
                            : null
                        }
                      ></i>
                    </span>
                  </BootstrapTooltip>
                  <span>
                    <ResponsiveEllipsis
                      text={rowData.itemCode}
                      maxLine="1"
                      displayInline
                    />
                  </span>
                </span>
              ) : (
                <React.Fragment>
                  <ResponsiveEllipsis text={rowData.itemCode} maxLine="1" />
                </React.Fragment>
              )}
            </React.Fragment>
          ),
          sortable: true,
        },
        {
          header: "Item Name",
          field: "itemName",
          body: (rowData) => (
            <React.Fragment>
              <ResponsiveEllipsis text={rowData.itemName} maxLine="1" />
            </React.Fragment>
          ),
          sortable: true,
        },
        {
          header: "Quantity",
          field: "qty",
          body: (rowData) => (
            <div>
              {rowData.qty} {rowData.uomName}
            </div>
          ),
          sortable: true,
        },
        {
          header: "Unit",
          field: "uomName",
          body: null,
          sortable: true,
          hidden: true,
        },
        {
          header: "Batch ID",
          field: "batchID",
          body: null,
          sortable: true,
        },
      ]}
    />
  );
}

export default SearchDeliveredItem;
